import Footer from "components/VerticalLayout/Footer";
import React from "react";
import { Container, Row, Col, Card, Button } from "reactstrap";

const Details = () => {
    return (
        <React.Fragment>
            {/* Hero Section */}
            <div
                style={{
                    background:
                        "linear-gradient(rgba(0,0,0,0.6), rgba(0,0,0,0.6)), url('/images/home-hero.jpg') center/cover",
                    color: "#fff",
                    textAlign: "center",
                    padding: "100px 20px",
                }}
            >
                <br></br>
                <h1 style={{ fontSize: "2.8rem", fontWeight: "bold" }}>
                    Your Real Estate Partner in Vadodara.
                </h1>
                <p style={{ fontSize: "1.2rem", marginTop: "15px" }}>
                    Simplifying buying, selling, and renting properties in the heart of Gujarat
                    with intelligent insights.
                </p>
                <div className="mt-4">
                    <Button
                        color="light"
                        outline
                        style={{ marginRight: "10px", borderRadius: "25px", padding: "10px 20px" }}
                    >
                        Find Your Dream Home
                    </Button>
                    <Button
                        color="light"
                        outline
                        style={{ borderRadius: "25px", padding: "10px 20px" }}
                    >
                        List Your Property
                    </Button>
                </div>
            </div>

            {/* Why Choose Us */}
            <Container className="py-5 text-white">
                <h2 className="text-center mb-4">The AIinRealEstate Advantage</h2>
                <Row className="gy-4">
                    <Col md={4}>
                        <Card className="p-4 shadow-sm bg-dark border-0 text-white h-100">
                            <h5>Expert Guidance</h5>
                            <p>
                                We combine local market knowledge with AI-driven data to give you
                                the best advice for your property journey.
                            </p>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="p-4 shadow-sm bg-dark border-0 text-white h-100">
                            <h5>Verified Listings</h5>
                            <p>
                                All our properties are carefully vetted to ensure transparency and
                                trust, saving you time and effort.
                            </p>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="p-4 shadow-sm bg-dark border-0 text-white h-100">
                            <h5>Seamless Process</h5>
                            <p>
                                From discovery to final documentation, we provide a smooth,
                                hassle-free experience for buyers, sellers, and tenants.
                            </p>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Featured Properties */}
            <Container className="py-5 text-white">
                <h2 className="text-center mb-4">Featured Properties</h2>
                <Row className="gy-4">
                    <Col md={4}>
                        <Card className="p-3 shadow-sm bg-dark border-0 text-white">
                            <img
                                src="/images/property1.jpg"
                                alt="Property in Alkapuri"
                                className="img-fluid rounded mb-3"
                            />
                            <h5>3 BHK Apartment - Alkapuri</h5>
                            <p>₹85,00,000 • 1800 sq.ft</p>
                            <Button color="light" outline size="sm">
                                View Details
                            </Button>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="p-3 shadow-sm bg-dark border-0 text-white">
                            <img
                                src="/images/property2.jpg"
                                alt="Property in Gotri"
                                className="img-fluid rounded mb-3"
                            />
                            <h5>2 BHK Flat - Gotri</h5>
                            <p>₹45,00,000 • 1200 sq.ft</p>
                            <Button color="light" outline size="sm">
                                View Details
                            </Button>
                        </Card>
                    </Col>
                    <Col md={4}>
                        <Card className="p-3 shadow-sm bg-dark border-0 text-white">
                            <img
                                src="/images/property3.jpg"
                                alt="Property in Vasna-Bhayli"
                                className="img-fluid rounded mb-3"
                            />
                            <h5>4 BHK Villa - Vasna-Bhayli</h5>
                            <p>₹1.25 Cr • 2500 sq.ft</p>
                            <Button color="light" outline size="sm">
                                View Details
                            </Button>
                        </Card>
                    </Col>
                </Row>
            </Container>
            {/* Footer */}
            <Footer />
        </React.Fragment>
    );
};

export default Details;
